import { render } from "./RemovePhoto.vue?vue&type=template&id=007f9a11&scoped=true"
import script from "./RemovePhoto.vue?vue&type=script&lang=js"
export * from "./RemovePhoto.vue?vue&type=script&lang=js"

import "./RemovePhoto.vue?vue&type=style&index=0&id=007f9a11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007f9a11"]])

export default __exports__